"use strict";

angular.module("core")
.component("timezone", {
    templateUrl: require("./timezone.component.html"),
    controller: function($scope, $resource, moment, appConfig) {
        $scope.timeZones = $resource(appConfig.API_SERVER + "/auth/time-zones/").query();
        if (this.guessTimeZone && !this.model) {
            this.model = moment.tz.guess();
        }
    },
    bindings: {
        model: "=",
        guessTimeZone: "<?",
        required: "<?"
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/timezone/timezone.component.js
// module id = 564
// module chunks = 0